import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { HomeRedirect } from "./components/HomeRedirect";
import CompleteProfileModal from "./components/CompleteProfileModal";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import PosterSignupPage from "./pages/PosterSignupPage";
import OpportunitiesPage from "./pages/OpportunitiesPage";
import OpportunityDetailPage from "./pages/OpportunityDetailPage";
import PostedProjectDetailPage from "./pages/PostedProjectDetailPage";
import SubmissionsPage from "./pages/SubmissionsPage";
import SubmissionDetailPage from "./pages/SubmissionDetailPage";
import InvitesPage from "./pages/InvitesPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminScraperPage from "./pages/AdminScraperPage";
import AdminPosterRequestsPage from "./pages/AdminPosterRequestsPage";
import AdminAnalyticsDashboardPage from "./pages/AdminAnalyticsDashboardPage";
import PosterDashboardPage from "./pages/PosterDashboardPage";
import CreateProjectPage from "./pages/CreateProjectPage";
import PosterProjectDetailPage from "./pages/PosterProjectDetailPage";
import PosterInvitesPage from "./pages/PosterInvitesPage";
import SettingsPage from "./pages/SettingsPage";
import PricingPage from "./pages/PricingPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import TeamManagementPage from "./pages/TeamManagementPage";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Landing page */}
                    <Route path="/" element={<LandingPage />} />
                    
                    {/* Public routes */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/poster-signup" element={<PosterSignupPage />} />
                    <Route path="/pricing" element={<PricingPage />} />

                    {/* Subscription routes */}
                    <Route path="/subscription/success" element={
                        <ProtectedRoute posterOnly>
                            <SubscriptionSuccessPage />
                        </ProtectedRoute>
                    } />

                    {/* Protected routes - Artists/Submitters/Admins only (NOT posters) */}
                    <Route path="/opportunities" element={
                        <ProtectedRoute artistOnly>
                            <OpportunitiesPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/opportunities/:syncId" element={
                        <ProtectedRoute artistOnly>
                            <OpportunityDetailPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/posted-projects/:projectId" element={
                        <ProtectedRoute artistOnly>
                            <PostedProjectDetailPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/submissions" element={
                        <ProtectedRoute artistOnly>
                            <SubmissionsPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/submissions/:submissionId" element={
                        <ProtectedRoute artistOnly>
                            <SubmissionDetailPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/invites" element={
                        <ProtectedRoute artistOnly>
                            <InvitesPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/settings" element={
                        <ProtectedRoute>
                            <SettingsPage />
                        </ProtectedRoute>
                    } />

                    {/* Poster routes */}
                    <Route path="/poster/dashboard" element={
                        <ProtectedRoute posterOnly>
                            <PosterDashboardPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/poster/projects/new" element={
                        <ProtectedRoute posterOnly>
                            <CreateProjectPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/poster/projects/:projectId" element={
                        <ProtectedRoute posterOnly>
                            <PosterProjectDetailPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/poster/invites" element={
                        <ProtectedRoute posterOnly>
                            <PosterInvitesPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/poster/team" element={
                        <ProtectedRoute posterOnly>
                            <TeamManagementPage />
                        </ProtectedRoute>
                    } />

                    {/* Admin routes */}
                    <Route path="/admin/users" element={
                        <ProtectedRoute adminOnly>
                            <AdminUsersPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/admin/scraper" element={
                        <ProtectedRoute adminOnly>
                            <AdminScraperPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/admin/poster-requests" element={
                        <ProtectedRoute adminOnly>
                            <AdminPosterRequestsPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/admin/analytics" element={
                        <ProtectedRoute adminOnly>
                            <AdminAnalyticsDashboardPage />
                        </ProtectedRoute>
                    } />

                    {/* Redirects */}
                    <Route path="/" element={<HomeRedirect />} />
                    <Route path="*" element={<HomeRedirect />} />
                </Routes>
                <CompleteProfileModal />
            </BrowserRouter>
            <Toaster 
                position="top-right"
                toastOptions={{
                    style: {
                        background: '#262626',
                        color: '#ffffff',
                        border: '1px solid #404040',
                    },
                }}
            />
        </AuthProvider>
    );
}

export default App;
